/* eslint-disable no-restricted-imports */
import React, {useMemo} from 'react'
import {Button} from '../../../../common/Button/Button'
import styles from './ActionButtons.module.scss'
import {T} from '@colonist/ui'
import {LobbyImage, ModeSettingEnum} from '@colonist/types'
import {getLobbyImagePath} from '../../../../../../../code/client/shared/scripts/ui_utils/Utils'
import {UIUtilsEjsVariables} from '../../../../../../../code/client/shared/scripts/UIUtilsEjsVariables'
import {useUIGameEndContext} from '../../../../contexts/UIGameEndContext'
import {useGameStore} from '../../../../store/GameStoreContext'

export function ShareButton() {
    const {onClickShare} = useUIGameEndContext()
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)

    const isSharingEnabled = useMemo(() => {
        const isMobile = UIUtilsEjsVariables.isUserOnMobile
        const isBeginnerMode = modeSetting == ModeSettingEnum.BeginnerModeClassic4P
        return !isBeginnerMode && !isMobile
    }, [modeSetting])

    if(!isSharingEnabled) return null

    return <Button
        className={styles.button}
        onClick={onClickShare}>
        <T id={{key: 'strings:game.endGame.cornerButton.share'}}/>
        {UIUtilsEjsVariables.isUserOnDiscord ?
            <img className={styles.icon} src={getLobbyImagePath(LobbyImage.DiscordIcon)}/> :
            <img className={styles.icon} src={getLobbyImagePath(LobbyImage.Share)}/>
        }
    </Button>
}
